var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgS3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_138_3690)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1996 4.94786L16.0496 12.8479L20.1996 20.7479L21.8996 19.7979V5.89786L20.1996 4.94786Z",
    fill: "#E25444"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1996 4.94786L11.8996 5.89786L7.67463 12.8479L11.8996 19.7979L20.1996 20.7479V4.94786Z",
    fill: "#7B1D13"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.44961 4.94786L2.09961 5.54786V20.1479L3.44961 20.7479L11.8996 12.8479L3.44961 4.94786Z",
    fill: "#58150D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.43147 4.93119L11.9108 7.28674V18.62L3.43147 20.7534V4.93119Z",
    fill: "#E25444"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9153 8.53121L8.31485 7.95341L11.9153 3.86451L15.5067 7.95341L11.9153 8.53121Z",
    fill: "#58150D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5067 7.95341L11.9108 8.54006L8.31485 7.95341V3.86451",
    fill: "#58150D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9153 17.1089L8.31485 17.7756L11.9153 21.2867L15.5067 17.7756L11.9153 17.1089Z",
    fill: "#58150D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8996 0.797852L8.2996 2.69785V7.94785L11.9108 6.9312L11.8996 0.797852Z",
    fill: "#7B1D13"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9108 9.82007L8.31485 10.2112V15.4531L11.9108 15.8645V9.82007Z",
    fill: "#7B1D13"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9108 18.6645L8.31485 17.7629V22.916L11.9108 24.7979V18.6645Z",
    fill: "#7B1D13"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5067 17.7629L11.9108 18.6645V24.7979L15.5067 22.916V17.7629Z",
    fill: "#E25444"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9108 9.82007L15.5067 10.2112V15.4531L11.9108 15.8645V9.82007Z",
    fill: "#E25444"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8996 0.797852L15.4996 2.69785V7.94785L11.8996 6.94785L11.8996 0.797852Z",
    fill: "#E25444"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_138_3690"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.797852)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgS3);
export default __webpack_public_path__ + "static/media/S3.f200d04c78dcfee29c4a15c67dd1510d.svg";
export { ForwardRef as ReactComponent };